import styled from "styled-components";

export const EditRoleStyles = styled.div`
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateX(8px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  .formHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;

    h2 {
      margin: 0;
    }
  }

  .headerActions {
    display: flex;
    align-items: center;
    gap: 12px;

    button {
      padding: 4px 10px;
      font-size: 13px;
      margin: -4px 0;
      animation: fadeIn 0.25s ease-out;
    }
  }
`;
